import { createContext, useMemo } from 'react';

export interface IEDStickyTableContext {
  responsiveRowHeight: number;
  bottomSpacing: number | string;
}

const defaultValues: IEDStickyTableContext = {
  responsiveRowHeight: 20,
  bottomSpacing: 0,
};

export const EDStickyTableContext =
  createContext<IEDStickyTableContext>(defaultValues);

export const EDStickyTableContextProvider: React.FC<
  React.PropsWithChildren<IEDStickyTableContext>
> = props => {
  const value: IEDStickyTableContext = useMemo(
    () => ({
      responsiveRowHeight: props.responsiveRowHeight,
      bottomSpacing: props.bottomSpacing,
    }),
    [props.responsiveRowHeight, props.bottomSpacing]
  );

  return (
    <EDStickyTableContext.Provider value={value}>
      {props.children}
    </EDStickyTableContext.Provider>
  );
};
